import { QueryClientProvider } from '@tanstack/react-query';
import type { JSX } from 'react';

import { queryClient } from '@/lib/query-client';

interface AppProviderProps {
  children: React.ReactNode;
}

export const AppProvider = ({ children }: AppProviderProps): JSX.Element => {
  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  );
};
